// @flow
import type { VerificationResult } from '../../types';
import axios from 'axios';

export default function verifyCode(
  token: string,
  code: string
): Promise<VerificationResult> {
  return new Promise((resolve, reject) => {
    const config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    };

    const baseUrl = process.env.REACT_APP_API_URL;

    axios
      .post(`${baseUrl}verifyCode`, { code }, config)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        console.error(error);
        reject();
      });
  });
}
